import { render, staticRenderFns } from "./CosmoformTemplateCreateDialog.vue?vue&type=template&id=28a6e4ec&scoped=true"
import script from "./CosmoformTemplateCreateDialog.vue?vue&type=script&lang=js"
export * from "./CosmoformTemplateCreateDialog.vue?vue&type=script&lang=js"
import style0 from "./CosmoformTemplateCreateDialog.vue?vue&type=style&index=0&id=28a6e4ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a6e4ec",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VSkeletonLoader,VTextField})


/* vuetify-loader */
import installDirectives from "!../../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Intersect from 'vuetify/lib/directives/intersect'
installDirectives(component, {Intersect})
